import {Switch, withStyles} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from 'prop-types';

const InactiveActiveSwitch = withStyles({
  switchBase: {
    'color': '#888888',
    '&$checked': {
      color: '#2C7847',
    },
    '&$checked + $track': {
      backgroundColor: '#2C7847',
    },
  },
  checked: {},
  disabled: {
    '&$checked .MuiSwitch-thumb': {
      backgroundColor: '#bcdfc6',
    },
  },
  track: {
    backgroundColor: '#999999',
  },
})(Switch);


/**
 * InactiveActiveSwitchState is a React component that renders a styled
 * switch with active/inactive states.
 *
 * @param {function} sideEffect - Callback function to run when the switch
 * state changes.
 * @param {boolean} checked - Initial checked state of the switch.
 * @param {{}} props - Additional props passed to the switch component.
 * @return {Element} The rendered React element.
 */
export default function InactiveActiveSwitchState({
  sideEffect = () => null,
  checked = false,
  ...props
}) {
  const [state, setState] = useState(checked);
  const onChange = (event) => {
    setState(event.target.checked);
    sideEffect();
  };

  useEffect(() => {
    setState(checked ?? false);
  }, [checked]);

  const label = props.label ?? (state ? 'Active' : 'Inactive');

  return (
    <>
      <FormControlLabel
        onChange={onChange}
        control={<InactiveActiveSwitch {...props} checked={state}/>}
        label={label}
      />
    </>
  );
}

InactiveActiveSwitchState.propTypes = {
  sideEffect: PropTypes.func,
  checked: PropTypes.bool,
  label: PropTypes.string,
};
